let Nav = {};
let header = $('.js-header');

Nav.init = function () {
    Nav.overlay();
    Nav.dropdown();
    Nav.transparency();
}

Nav.overlay = function () {
    let cartOverlay = $('.js-cart-overlay');
    let navBarCollapse = $('#navbarNav');

    // Cart Overlay
    if (!$('body').is('.isApple, .AndroidOS')) {
        cartOverlay.hover(function () {
            $('body').addClass('cart-overlay');
        }, function () {
            $('body').removeClass('cart-overlay');
        });
    }

    navBarCollapse.on('show.bs.collapse', function () {
        $('body').addClass('nav-overlay');
        document.documentElement.classList.add('no-scroll');
        window.disableBodyScroll(true, '.navbar-collapse');

    })

    let resetMenu = $('.js-menu-dropdown, .js-menu-body, .js-submenu-dropdown, .js-submenu-body')

    navBarCollapse.on('hidden.bs.collapse', function () {
        $('body').removeClass('nav-overlay');
        document.documentElement.classList.remove('no-scroll');
        window.disableBodyScroll(false, '.navbar-collapse');
        resetMenu.removeClass('show');
        $('body').removeClass('first-menu second-menu');

    })
};

Nav.dropdown = function () {
    // Menu Dropdown Mobile
    let menuToggle = $('.js-menu-dropdown');

    menuToggle.click(function () {
        let thisMenu = $(this);

        if (thisMenu.hasClass('show')) {
            thisMenu.next('.js-menu-body').removeClass('show');
            thisMenu.removeClass('show');
        } else {
            menuToggle.next('.js-menu-body').removeClass('show');
            menuToggle.removeClass('show');
            thisMenu.next('.js-menu-body').addClass('show');
            thisMenu.addClass('show');

            if (thisMenu.hasClass('is-full')) {
                $('body').addClass('first-menu');
                window.disableBodyScroll(false, '.navbar-collapse');
                window.disableBodyScroll(true, '.js-menu-body');
            }
        }
    });

    let menuClose = $('.js-menu-dropdown-close');

    menuClose.click(function () {
        let thisMenu = $(this);
        $('.js-menu-dropdown').removeClass('show');
        thisMenu.closest('.js-menu-body').removeClass('show');
        $('body').removeClass('first-menu');

        window.disableBodyScroll(false, '.js-menu-body');
        window.disableBodyScroll(true, '.navbar-collapse');
    });


    // Submenu Dropdown Desktop
    if (window.matchMedia('(min-width: 1024px)').matches) {
        let subMenuItem = $('.subnav-left-menu-item');
        let subMenu = $('.subnav-left-menu');
        subMenuItem.hover(
            function () {
                let thisMenu = $(this);
                let subMenuListLength = thisMenu.find('.js-submenu-body ul li').length;
                let subMenuListHeight = (subMenuListLength * 40) + 50;
                subMenu.css('min-height', subMenuListHeight + 'px');
                subMenuItem.addClass('not-active');
                thisMenu.removeClass('not-active');
            },
            function () {
                subMenu.attr('style', '');
                subMenuItem.removeClass('not-active');
            }
        );
    }

    // Submenu Dropdown Mobile
    let subMenuToggle = $('.js-submenu-dropdown');

    subMenuToggle.click(function () {
        let thisMenu = $(this);

        if (thisMenu.hasClass('show')) {
            thisMenu.next('.js-submenu-body').removeClass('show');
            thisMenu.removeClass('show');
        } else {
            subMenuToggle.next('.js-submenu-body').removeClass('show');
            subMenuToggle.removeClass('show');
            thisMenu.next('.js-submenu-body').addClass('show');
            thisMenu.addClass('show');
            $('body').addClass('second-menu');
            $('body').removeClass('first-menu');

            window.disableBodyScroll(false, '.js-menu-body');
            window.disableBodyScroll(true, '.js-submenu-body');
        }
    });

    let subMenuClose = $('.js-submenu-dropdown-close');

    subMenuClose.click(function () {
        let thisMenu = $(this);
        $('.js-submenu-dropdown').removeClass('show');
        thisMenu.closest('.js-submenu-body').removeClass('show');
        $('body').removeClass('second-menu');
        $('body').addClass('first-menu');

        window.disableBodyScroll(false, '.js-submenu-body');
        window.disableBodyScroll(true, '.js-menu-body');
    });

    // Nav toggle
    let navToggle = $('.js-nav-toggle');
    let sideOverlay = $('.side-overlay');
    let wpAdminbar = $('#wpadminbar');
    let wpAdminbarHeight = 0;

    navToggle.click(function () {

        if (wpAdminbar) {
            wpAdminbarHeight = wpAdminbar.innerHeight();
        }

        sideOverlay.css('top', (header.innerHeight() + wpAdminbarHeight) + 'px')
    });

};

Nav.transparency = function () {
    if (!header.hasClass('js-nav-transparent')) {
        return;
    } else {
        if( $('body').hasClass('home') ){
            $('body').addClass('no-padding-top');
        }

        if( $('body').hasClass('tax-silk_category') ){
            $('.text-intro-block').addClass('extend-category-bg');
            $('body').addClass('no-padding-top');
        }

		if($(window).scrollTop() < 120) {
			header.addClass('is-transparent');
		} else {
			header.removeClass('js-nav-transparent');
		}

        $(window).scroll(() => {
            let top_of_screen = $(window).scrollTop();
            if (top_of_screen > 120) {
				header.removeClass('is-transparent');
            } else {
				if(header.hasClass('js-nav-open')){
					return;
				} else {
					header.addClass('is-transparent');
				}
				
            }
        });

		const navMouseIn = () => {
			header.addClass('js-nav-open');
			if(header.hasClass('js-nav-transparent')){
				header.removeClass('is-transparent');

			}
		};

		const navMouseOut = () => {
			header.removeClass('js-nav-open');
			if(header.hasClass('js-nav-transparent')){
				if($(window).scrollTop() < 120) {
					header.addClass('is-transparent');
				} else {
					return;
				}
			}
		};
	
        header.hover(navMouseIn, navMouseOut)
    }
};

Nav.init();


// WEBPACK FOOTER //
// ./scripts/components/nav.js